import React from "react";

const PartnerPageHeader = ({ tag, title, titleAccent, subtitle, children }) => (
  <header className="mb-8 md:mb-10">
    {tag && (
      <p className="font-mono text-[10px] tracking-[0.2em] text-partner-muted uppercase mb-3">
        {tag}
      </p>
    )}
    <h1 className="text-2xl sm:text-3xl font-bold leading-tight mb-3">
      {title}
      {titleAccent && <> <span className="gradient-text">{titleAccent}</span></>}
    </h1>
    {subtitle && (
      <p className="text-partner-muted font-body max-w-2xl leading-relaxed text-sm sm:text-base">
        {subtitle}
      </p>
    )}
    {children}
  </header>
);

export default PartnerPageHeader;
